export const drawerWidth = 304;
export const maxContentWidth = 1148;
